export class VoceCorrelataClassificaDTO {
    id: string;
    codice: string;
    nome: string;
    motivo: string;
    nota: string;
}